/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { CreateEventComposerSection, DataActionConditionType, getTypeIcon } from 'cio/utils/campaigns/data-action';

interface DataActionTypeValueLabelComponentArgs {
  condition?: CreateEventComposerSection;
  serializedCondition?: string;
  truncate?: boolean;
}
export default class DataActionTypeValueLabelComponent extends Component<DataActionTypeValueLabelComponentArgs> {
  DataActionConditionType = DataActionConditionType;

  get truncate() {
    return this.args.truncate ?? true;
  }

  get icon() {
    if (this.condition == null) {
      return null;
    }

    return getTypeIcon(this.condition.type);
  }

  get condition() {
    if (this.args.condition != null) {
      return this.args.condition;
    }

    if (this.args.serializedCondition != null) {
      try {
        return JSON.parse(this.args.serializedCondition);
      } catch (e) {
        return null;
      }
    }

    return null;
  }
}
